import React, { useEffect } from "react"
import styled from "styled-components"
import { observer } from "mobx-react"

import useInject from "~/hooks/useInject"
import { STATES } from "~/utilities/constants"
import InputTitle from "~/components/traffic/lookup/Forms/Elements/InputTitle"

const Container = styled.div`
  position: relative;
`
const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  border: solid 1px ${props => props.theme.colors.ui.inputBorder};
  background-color: ${props => props.theme.colors.background.page};
  padding: 0.5em;
  border-radius: 4px;
  margin-top: 1em;
`

const Plate = styled.button.attrs({ type: "button"})`
  scroll-snap-align: start end;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  background: none;
  background-color: ${props => props.theme.colors.background.main};
  border: none;
  border-radius: 4px;
  padding: 0.5em;
  font-size:1em;
  font-family: ${(props) => props.theme.fonts.avenirNextDemi};
  color: ${(props) => props.theme.colors.text.label};
  transition: all 500ms ease;
  outline:none;
  margin: 0;
  small {
    font-size: 0.9em;
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
    font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  }

  &:focus {
    box-shadow: 0 0 0 3px ${props => props.theme.colors.primary};
  }
  &:not(:last-child) {
    margin-right: 0.5em;
  }
`

const mapStore = store => ({
  userPlates: store.plates,
  auth: store.auth
})

const PlateSelector = ({ selectPlate }) => {
  const { userPlates, auth } = useInject(mapStore)
  useEffect(() => {
    if(auth.isLoggedIn) userPlates.loadIfNecessary()
  }, [auth.isLoggedIn])
  if (!auth.isLoggedIn) return null
  if (!userPlates.plates || !userPlates.plates.length) return null
  return (
    <Container>
      <InputTitle>Saved Plates</InputTitle>
      <ListContainer>
        {userPlates.plates.map( plate => {
          const state = plate.state && STATES[plate.state]
          if(!state) return null
        return (
          <Plate onClick={() => selectPlate(plate.plateNumber, plate.state)} key={`${plate.plateNumber}-${plate.state}`}>
            <small>{STATES[plate.state]}</small>
            {plate.plateNumber}
          </Plate>
)
    })}
      </ListContainer>
    </Container>
  )
}

export default observer(PlateSelector)
